<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{ 'events.cardTitle' | t }}</h5>
        <h6 class="card-subtitle mb-2 text-muted">{{ 'selectExportTypeBelow' | t }}</h6>

        <hr />

        <mat-checkbox color="primary" name="includeMois" [(ngModel)]="includeChecked"
            >{{ 'includeClosedMoisCheckbox' | t }}</mat-checkbox
        >

        <hr />

        @if (permService.permissions.HasEventExportAccess) {
            <button class="btn btn-default me-2 mb-2" (click)="downloadEvent(ExportType.Events)">
                {{ 'events.eventsButton' | t }}
            </button>
            <button class="btn btn-default me-2 mb-2" (click)="downloadEvent(ExportType.EventsAll)">
                {{ 'events.eventsMoisActionsButton' | t }}
            </button>
            <button
                class="btn btn-default me-2 mb-2"
                (click)="downloadEvent(ExportType.DataBreachesAndMoi)"
            >
                {{ 'events.dataBreachMoisButton' | t }}
            </button>
            <button
                class="btn btn-default me-2 mb-2"
                (click)="downloadEvent(ExportType.EventEmailNotifications)"
            >
                {{ 'events.controlDesignEmailButton' | t }}
            </button>
            <button class="btn btn-default me-2 mb-2" (click)="exportEventsRisksAndControls()">
                {{ 'events.eventsWithRisksControlsButton' | t }}
            </button>
        }
    </div>
</div>
